export default function TrackingPixel({src}: {src: string}) {
  return (
    <noscript>
      <img height="1" width="1" style={{display: 'none'}} src={src} alt="" />
    </noscript>
  )
}
